// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar_avatar__Z4qyU","small":"Avatar_small__JNhvu","medium":"Avatar_medium__ssyuI","large":"Avatar_large__B8c8G"};